<template>
  <div class="cmp-artist-payments dbox">
    <NTable
      class="artist-payment-list"
      :headers="invoicelineHeaders"
      :items="selectedInvoice[payment_prop]"
      :config="tableConfig"
    >
      <template v-slot:item="{ item }">
        <tr :title="'Click to see Contact Details'">
          <td :class="['date']">
            <DatePicker
              :disabled="selectedInvoice.disabled"
              id="date"
              :value="item['date']"
              :controlType="'input'"
              @valuechanged="(name, value) => onArtistPaymentDateUpdate(name, value, item)"
            />
          </td>
          <td :class="['recipient']">
            <input 
              class="dbox-table--textfield"
              type="text"
              name="recipient"
              id="recipient"
              :disabled="selectedInvoice.disabled"
              :value="item['recipient']"
              v-on:blur="e => onTextInputBlur(e, 'recipient', item)"
            >
          </td>
          <td :class="['notes']">
            <input 
              class="dbox-table--textfield"
              type="text"
              name="notes"
              id="notes"
              :disabled="selectedInvoice.disabled"
              :value="item['notes']"
              v-on:blur="e => onTextInputBlur(e, 'notes', item)"
            >
          </td>
          <td class="amount">
            <input 
              class="dbox-table--textfield"
              type="text"
              name="amount"
              id="amount"
              :disabled="selectedInvoice.disabled"
              :value="item['amount']"
              v-on:blur="e => onTextInputBlur(e, 'amount', item)"
            >
          </td>
          <td :class="['currency']">
            <Dropdown 
              class="dbox-table--dropdown"
              :disabled="selectedInvoice.disabled"
              :options="selectedInvoice.currenciesTV"
              :selected="selectedInvoice.currenciesTV.find(v => v.value == item.currency_id)"
              v-on:selectedChange="e => onArtistPaymentCurrencyChange('currency_id', e, item)"
            ></Dropdown>
          </td>
          <td :class="['exchangerate']">
            <input type="text" class="dbox-table--textfield"
              name="exchangerate"
              id="exchangerate"
              :disabled="selectedInvoice.disabled"
              :value="item['exchangerate']"
              v-on:blur="e => onTextInputBlur(e, 'exchangerate', item)"
            >
          </td>
          <td :class="['EUR']">
            {{getAmountInEUR(item)}}
          </td>
          <td :class="['notes']">
            
          </td>
        </tr>
      </template>
      <template #tfoot>
        <tr>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td>Total {{forwardType === 'artist' ? $t('artist'): $t('agent')}} </td>
          <td> {{$dft.curr(totalValue)}} </td>
          <td></td>
        </tr>
      </template>
    </NTable>
    <!-- <div class="artist-payment-list-container">
    </div>
    <div class="artist-payment-list-footer">
       <div class="left">

       </div>
       <div class="label">
        <label>
          Total
        </label>
       </div>
       <div class="value">
        <div class="val">
          {{$dft.curr(totalValue)}}
        </div>
       </div>
       <div class="right">

       </div>
    </div> -->
    <div class="dbox-title-bar--options">
      <img 
        @click="addArtistPayment" 
        src="static/icons/add-icon.svg" 
        class="dt-icon v4" 
        :alt="$t('add_artist_payment')"
        :title="$t('add_artist_payment')"
      >
      <!-- <div class="button">
          <div class="dt-icon-container">
            <img 
              @click="addArtistPayment" 
              src="static/icons/add.svg" 
              class="dt-icon" 
              alt="">
          </div>
        </div> -->
    </div>
  </div>
</template>

<script>

import { EventHooks } from '../../../../plugins/text-field';
import NTable from "@/plugins/datatable/datatable";
import { createNTableConfig, createTableHeader } from '../../../../plugins/datatable';
import { mapGetters } from 'vuex';
import { parseNumber } from '../../../../utility';
import { tv } from '../../../../models/text-value.model';
import DatePicker from '@plugins/text-field/date-picker';


export default {
  components: {
    NTable,
    DatePicker
  },
  props: {
    selectedInvoice: {
      required: true,
    },
    forwardType: {
      Type: String,
      default: () => 'artist'
    }
  },
  data: () => ({
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: false,

        validationEvent: EventHooks.OnBlur,
        valueChangedEvent: EventHooks.OnBlur,
      },

      tableConfig: createNTableConfig({
        headerStyle: 2,
        fullHeight: true,
        footer: true
      })
    }),
  computed:  {
    invoicelineHeaders: () => [
        createTableHeader('artist'),
        createTableHeader('recipient'),
        createTableHeader('notes'),
        createTableHeader('amount'),
        createTableHeader('currency'),
        createTableHeader('exchange_rate'),
        createTableHeader('EUR'),
        createTableHeader('options'),
      ],
    totalValue: function() {
      return this.selectedInvoice[this.payment_prop].reduce((accm, cur) => {
        accm += this.getAmount(cur);
        return accm;
      }, 0);
    },
    type: function() {
      return {
        type: this.forwardType
      };
    },
    payment_prop: function() {
      return this.forwardType == 'artist' ? 'artist_payments' : 'agent_payments';
    },
  },
  methods: {
    onTextInputBlur: function(event, name, item) {
      this.$emit('changed', { 
        name, 
        value: event.target.value,
        item,
        ...this.type,
      });
    },
    getAmount: function(item) {
      return (item.exchangerate ? item.exchangerate : 1) * (item.amount ? item.amount : 0);
    },
    getAmountInEUR: function(item) {
      return this.$dft.curr(this.getAmount(item));
    },
    onArtistPaymentCurrencyChange: function(name, value, item) {
      this.$emit('changed', { 
        name, 
        value: value.value,
        item,
        ...this.type
      });
    },
    addArtistPayment: function(){
      this.$emit('add_forward_payment', this.type);
    },
    onArtistPaymentDateUpdate: function(name, value, item) {
      this.$emit('changed', {
        name, 
        value, 
        item,
        ...this.type,
      });
    }
    //MARK: Methods
  }
}
</script>


<style lang="scss">

.cmp-artist-payments{
  display: flex;
  flex-direction: column;

  .dt-ntable {
    th:nth-child(8),
    td:nth-child(8) {
      max-width: 25px;
    }
  }
  .dropdown--main__text {
    padding-top: 4px;
    padding-left: 4px;
  }
}
</style>
